import { render, staticRenderFns } from "./docAlert.vue?vue&type=template&id=a4299dd4&scoped=true"
import script from "./docAlert.vue?vue&type=script&lang=js"
export * from "./docAlert.vue?vue&type=script&lang=js"
import style0 from "./docAlert.vue?vue&type=style&index=0&id=a4299dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4299dd4",
  null
  
)

export default component.exports